/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Asia_Shanghai2Inputs */

const he_timezone_asia_shanghai2 = /** @type {(inputs: Timezone_Asia_Shanghai2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shanghai`)
};

const en_timezone_asia_shanghai2 = /** @type {(inputs: Timezone_Asia_Shanghai2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shanghai`)
};

/**
* | output |
* | --- |
* | "Shanghai" |
*
* @param {Timezone_Asia_Shanghai2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_asia_shanghai2 = /** @type {((inputs?: Timezone_Asia_Shanghai2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Asia_Shanghai2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_asia_shanghai2(inputs)
	return en_timezone_asia_shanghai2(inputs)
});
export { timezone_asia_shanghai2 as "timezone_Asia_Shanghai" }